/*
 * careers translations for the "en" locale.
 *
 * Split out of locales/en.js so this feature's copy stops shipping to
 * every route in the app. See locales/careers/index.js.
 */
export default {
  careers: {
    apply: "Apply",
    section: "Section",
    jobBrief: "Job Brief",
    requirements: "Requirements",
    notHiring: "Not Hiring Right Now",
    jobs: [
      {
        id: 1,
        title: "AP Accountant",
        section: "Accounting",
        jobBrief: `<ul>
  <li style="margin-bottom:5px";>Manage all accounting transactions</li>
  <li style="margin-bottom:5px";>Prepare budget forecasts</li>
  <li style="margin-bottom:5px";>Publish financial statements in time</li>
  <li style="margin-bottom:5px";>Reconcile accounts payable</li>
  <li style="margin-bottom:5px";>Ensure timely bank payments</li>
  <li style="margin-bottom:5px";>Compute taxes and prepare tax returns</li>
  <li style="margin-bottom:5px";>Manage balance sheets and profit/loss statements</li>
  <li style="margin-bottom:5px";>Report on the company’s financial health and liquidity</li>
  <li style="margin-bottom:5px";>Audit financial transactions and documents</li>
  <li style="margin-bottom:5px";>Reinforce financial data confidentiality and conduct database backups when necessary</li>
  <li style={{ }}>Comply with financial policies and regulations</li>
</ul>
`,
        requirements: `<ul>
  <li style="margin-bottom:5px";>Work experience as an AP Accountant from 2 to 5 years</li>
  <li style="margin-bottom:5px";>Excellent knowledge of accounting regulations and procedures, including the Generally Accepted Accounting Principles (GAAP)</li>
  <li style="margin-bottom:5px";>Advanced MS Excel skills including Vlookups and pivot tables</li>
  <li style="margin-bottom:5px";>Experience with general ledger functions</li>
  <li style="margin-bottom:5px";>Strong attention to detail and good analytical skills</li>
  <li style="margin-bottom:5px";>BSc in Accounting, Finance or relevant degree</li>
  <li style="margin-bottom:5px";>Additional certification (CPA or CMA) is a plus</li>
</ul>
`,
      },
      {
        id: 2,
        title: "AR Accountant",
        section: "Accounting",
        jobBrief: `<ul>
              <li style="margin-bottom:5px";>
                Manage all accounting transactions
              </li>
              <li style="margin-bottom:5px";>Prepare budget forecasts</li>
              <li style="margin-bottom:5px";>
                Publish financial statements in time
              </li>
              <li style="margin-bottom:5px";>
                Reconcile accounts receivables
              </li>
              <li style="margin-bottom:5px";>
                Ensure timely bank payments
              </li>
              <li style="margin-bottom:5px";>
                Compute taxes and prepare tax returns
              </li>
              <li style="margin-bottom:5px";>
                Manage balance sheets and profit/loss statements
              </li>
              <li style="margin-bottom:5px";>
                Report on the company’s financial health and liquidity
              </li>
              <li style="margin-bottom:5px";>
                Audit financial transactions and documents
              </li>
              <li style="margin-bottom:5px";>
                Reinforce financial data confidentiality and conduct database
                backups when necessary
              </li>
              <li style="margin-bottom:5px";>
                Comply with financial policies and regulations
              </li>
            </ul>`,
        requirements: `<ul>
              <li style="margin-bottom:5px";>
                Work experience as an AR Accountant from 2 to 5 years
              </li>
              <li style="margin-bottom:5px";>
                Excellent knowledge of accounting regulations and procedures,
                including the Generally Accepted Accounting Principles (GAAP)
              </li>
              <li style="margin-bottom:5px";>
                Advanced MS Excel skills including Vlookups and pivot tables
              </li>
              <li style="margin-bottom:5px";>
                Experience with general ledger functions
              </li>
              <li style="margin-bottom:5px";>
                Strong attention to detail and good analytical skills
              </li>
              <li style="margin-bottom:5px";>
                BSc in Accounting, Finance or relevant degree
              </li>
              <li style="margin-bottom:5px";>
                Additional certification (CPA or CMA) is a plus
              </li>
            </ul>`,
      },
      {
        id: 3,
        title: "Sales Representative",
        section: "Sales",
        jobBrief: `<ul>
              <li style="margin-bottom:5px";>
                Develop and maintain relationships with product vendors and
                suppliers
              </li>
              <li style="margin-bottom:5px";>
                Demonstrate different installment programs and packages to
                clients
              </li>
              <li style="margin-bottom:5px";>
                Provide support to clients from application submission until the
                sale is closed
              </li>
              <li style="margin-bottom:5px";>
                Ensure smooth customer experience through coordination with
                relevant departments
              </li>
            </ul>`,

        requirements: ` <ul>
              <li style="margin-bottom:5px";>Bachelor's degree </li>
              <li style="margin-bottom:5px";>
                0 - 3 years of experience in sales
              </li>
              <li style="margin-bottom:5px";>
                Very high communication skills
              </li>
              <li style="margin-bottom:5px";>
                Ability to work under pressure
              </li>
            </ul>`,
      },
    ],
  },
  jobs: {
    title: "Jobs",
    content:
      "With the company's expansions, we are always looking to add bright calibers to our team, which includes more than 2500 employees. The company has a low turnover rate, with many of its managers continuing to work since its inception. We believe in developing our human capital to achieve our desired growth as individuals, teams, and institutions. If you would like to join us, please fill out the form.",
    jobs_categories: ["All", "IT", "Marketing", "Sales", "Accounting"],
  },
};
